import { render, staticRenderFns } from "./SelectDicValue.vue?vue&type=template&id=2c42e31f&scoped=true"
import script from "./SelectDicValue.vue?vue&type=script&lang=js"
export * from "./SelectDicValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42e31f",
  null
  
)

export default component.exports